<template>
  <VpCheckbox ref='checkbox' class="vcl-table-checkbox" v-bind="{ value: isSelected, styles: { size: 12, borderRadius: '2px', ...styles }, icon }" @input="itemSelected" />
</template>

<script>
import VpCheckbox from '../vp-checkbox/VpCheckbox.vue';

export default {
  name: 'VpTableCheckbox',
  components: {
    VpCheckbox,
  },
  props: {
    index: {
      type: Number,
      default: -1,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: 'white-check'
    },
    styles: {
      type: Object,
      default: () => ({}),
    }
  },
  emits: ['selected'],
  computed: {
    isSelected() {
      return this.selected;
    },
  },
  methods: {
    itemSelected(value) {
      if (this.index === -1) {
        return this.$emit('selected', value);
      }
      return this.$emit('selected', { index: this.index, value });
    },
  },
};
</script>

<style lang="scss" scoped>
  .vcl-table-checkbox {
    display: flex;
    justify-content: center !important;
    align-items: center !important;
  }
</style>
